import React from 'react';
import Carousel from 'react-bootstrap/Carousel';

import image1 from "../assets/images/slide_1.png";
import image2 from "../assets/images/slide_2.png";
import image3 from "../assets/images/slide_3.png";
import image4 from "../assets/images/slide_4.png";
import image5 from "../assets/images/slide_5.png";

const DarkVariantExample: React.FC = () => {
  const images = [image1, image2, image3,image4,image5];
  return (
    <div className='col-12'>
      <center>
        <Carousel>
        {images.map((src, index) => (
          <Carousel.Item key={index}>
            <img style={{borderRadius: "15px", boxShadow: "revert" }} className="d-block w-80" src={src} alt={`Slide ${index + 1}`} />
          </Carousel.Item>
        ))}
      </Carousel>
  </center>
  </div>);
    // <Carousel data-bs-theme="light" style={{width:"100px"}}>
    //   <Carousel.Item>
    //     <img
    //       className="d-block w-100"
    //       src={_first_slide}
    //       alt="First slide"
    //     />
    //     <Carousel.Caption>
    //       <h5>First slide label</h5>
    //       <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
    //     </Carousel.Caption>
    //   </Carousel.Item>
    //   <Carousel.Item>
    //     <img
    //       className="d-block w-100"
    //       src="holder.js/800x400?text=Second slide&bg=eee"
    //       alt="Second slide"
    //     />
    //     <Carousel.Caption>
    //       <h5>Second slide label</h5>
    //       <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    //     </Carousel.Caption>
    //   </Carousel.Item>
    //   <Carousel.Item>
    //     <img
    //       className="d-block w-100"
    //       src="holder.js/800x400?text=Third slide&bg=e5e5e5"
    //       alt="Third slide"
    //     />
    //     <Carousel.Caption>
    //       <h5>Third slide label</h5>
    //       <p>
    //         Praesent commodo cursus magna, vel scelerisque nisl consectetur.
    //       </p>
    //     </Carousel.Caption>
    //   </Carousel.Item>
    // </Carousel>
  //);
};

export default DarkVariantExample;